/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminAlembicStatusResponse } from '../models/AdminAlembicStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminMigrationsService {

    /**
     * Get Admin Migration Status
     * @returns AdminAlembicStatusResponse Successful Response
     * @throws ApiError
     */
    public static getAdminMigrationStatusApiV1AdminMigrationsGet(): CancelablePromise<AdminAlembicStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/migrations',
        });
    }

}
